import script from "./object_headerV2.vue?vue&type=script&setup=true&lang=js"
export * from "./object_headerV2.vue?vue&type=script&setup=true&lang=js"

import "./object_headerV2.vue?vue&type=style&index=0&id=70dbabae&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70dbabae"]])

export default __exports__